module.exports = __webpack_public_path__ + "img/aboutUs.bfa7f012.png";